<template>
  <ReaderDrawer v-model="menuOpen">
    <template #header>
      <h2 class="font-medium text-lg">
        {{ t(key("header")) }}
      </h2>
    </template>
    <div class="px-2 divide-y dark:divide-neutral-700">
      <p
        v-for="footnote in footnoteMap.keys()"
        :id="footnote"
        class="py-4 px-2 hover:bg-neutral-100 dark:hover:bg-neutral-800 cursor-pointer"
        @click.stop="scrollElementIntoViewById(`footnote-number-${footnote}`)"
      >
        <sup class="novel-footnote-reference-number">
          {{ footnote.split("=").at(-1) }}
        </sup>
        <span class="ml-1">{{ footnoteMap.get(footnote) }}</span>
      </p>
    </div>
  </ReaderDrawer>
</template>

<script setup lang="ts">
import { getFootnoteMap, type TextBlock } from "~/src/novel/core";
import {
  type NovelSettingsInterface,
  scrollElementIntoViewById,
} from "~/src/novel/reader";

const { t } = useI18n();
const key = useI18nKey("components.novel.drawer.novelDrawerFootnotes");

const { text } = defineProps<{
  text: TextBlock[];
  solo?: boolean;
}>();
const secondaryMenuOpen = defineModel<
  NovelSettingsInterface["secondaryMenuOpen"]
>("secondaryMenuOpen", { default: false });

const menuOpen = computed({
  get: () => secondaryMenuOpen.value === "footnotes",
  set: (v) => {
    if (v) secondaryMenuOpen.value = "footnotes";
    else secondaryMenuOpen.value = false;
  },
});

watch(
  () => text,
  () => (menuOpen.value = false),
);

const footnoteMap = computed(() => getFootnoteMap(text));
</script>

<style scoped lang="postcss"></style>
